var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLayoutH2 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 36,
  viewBox: "0 0 48 36",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M44 0a4 4 0 0 1 4 4v28a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4zm0 4H4v28h40zm-8 17v2h-8v-2zm-24.123-8v.87l-1.039.128v3.51h4.137v-3.516l-1.033-.123V13h3.853v.87l-1.045.128v8.017l1.106.244V23h-3.982v-.74l1.1-.239v-3.483h-4.136v3.477l1.1.238V23H8.013v-.747l1.045-.245v-8.003L8 13.869V13zm10.209 1.867c1.787 0 2.72 1.101 2.72 2.254 0 1.777-1.477 3.258-3.944 4.894l3.376-.38.581-.824.736.238L25.14 23h-5.918l-.254-.695c2.016-1.282 4.007-3.181 4.007-4.707 0-.74-.42-1.578-1.453-1.578-.934 0-1.7.547-2.145.934l-.427-.683c.359-.521 1.589-1.404 3.135-1.404M40 17v2H28v-2zm-4-4v2h-8v-2z"
})));
export default SvgLayoutH2;